/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Renderer.Events
 */

module.exports = {

    POST_RENDER: require('./POST_RENDER_EVENT'),
    PRE_RENDER: require('./PRE_RENDER_EVENT'),
    RENDER: require('./RENDER_EVENT'),
    RESIZE: require('./RESIZE_EVENT')

};
